import { render } from "./PlusSvg.vue?vue&type=template&id=21f90804"
import script from "./PlusSvg.vue?vue&type=script&lang=ts"
export * from "./PlusSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script